import axios from "../../axios/axios-censo";
import axiosApi from "../../axios/axios-api";

export const pegaUnidadesMeianoite = ({ commit }, payload) => {
    return axios
    .get("/relatorios/listarUnidadesTaxaOcupacao.php")
    .then(resp => {
        resp.data.status == true ? commit('setUnidadesMeianoite', resp.data.dados) : commit('setUnidadesMeianoite', new Array())
    })
    .catch(error => {
        console.error(error)
    });
};

export const listaTaxaOcupacaoMeianoite = ({ commit }, payload) => {
    commit("sessao/setLoading", true, { root: true })

    let config = {
        params: {
            dataInicial: payload.dataInicial,
            dataFinal: payload.dataFinal,
        }
    }

    return axios
    .get("/relatorios/listarTaxaOcupacao.php", config)
    .then(resp => {
        resp.data.status == true ? commit('setTaxaOcupacaoMeianoite', resp.data.dados) : commit('setTaxaOcupacaoMeianoite', new Array())
        commit("sessao/setLoading", false, { root: true })
    })
    .catch(error => {
        console.error(error)
        commit("sessao/setLoading", false, { root: true })
    });
};

export const listaTaxaOcupacaoUnidadeMeianoite = ({ commit }, payload) => {
    commit("sessao/setLoading", true, { root: true })

    let config = {
        params: {
            dataInicial: payload.dataInicial,
            dataFinal: payload.dataFinal,
            cnes: payload.cnes
        }
    }

    return axios
    .get("/relatorios/listarTaxaOcupacaoPorUnidade.php", config)
    .then(resp => {
        resp.data.status == true ? commit('setTaxaOcupacaoMeianoite', resp.data.dados) : commit('setTaxaOcupacaoMeianoite', new Array())
        commit("sessao/setLoading", false, { root: true })
    })
    .catch(error => {
        console.error(error)
        commit("sessao/setLoading", false, { root: true })
    });
};

export const mapaLeitos = ({ commit, rootGetters }, payload) => {
    commit("sessao/setLoading", true, { root: true })

    let token = rootGetters['sessao/getUsuario'].tokenAcesso

    let config = {
        headers: { Authorization: "Bearer " + token },
        params: {
          cnes: payload
        }
    }
    
    return axiosApi
    .get("api/censo/listar", config)
    .then(resp => {
        commit("sessao/setLoading", false, { root: true })
        resp.data.status == true ? commit("setMapaLeitos", resp.data.dados) : commit("setMapaLeitos", null)
    })
    .catch(error => {
        commit("sessao/setLoading", false, { root: true });
        console.error(error)
    });

};


export const consultarPacienteInternado = ({ commit }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit('setErrorCns', null)

    let config = {
        params: {
          cns: payload.cns,
          'g-recaptcha-response': payload.captcha
        }
    }

    return axios
    .get("consultarPacienteInternado.php", config)
    .then(resp => {
        if (resp.data.status === true) commit('setPacienteInternado', resp.data.dados)
        if (resp.data.status === false) {
            commit('setPacienteInternado', null)
            commit('setErrorCns', resp.data.msg)
        }
        commit("sessao/setLoading", false, { root: true })
    })
    .catch(error => {
        console.error(error)
        commit("sessao/setLoading", false, { root: true })
    });
};


export const historicoInternacoes = ({ commit }, payload) => {
    commit("sessao/setLoading", true, { root: true })
    commit('setHistoricoInternacoesError', null)

    let config = {
        params: {
          cns: payload
        }
    }

    return axios
    .get("/relatorios/listarHistoricoInternacoes.php", config)
    .then(resp => {
        if (resp.data.status === true) commit('setHistoricoInternacoes', resp.data.dados)
        if (resp.data.status === false) {
            commit('setHistoricoInternacoes', null)
            commit('setHistoricoInternacoesError', resp.data.msg)
        }
        commit("sessao/setLoading", false, { root: true })
    })
    .catch(error => {
        console.error(error)
        commit("sessao/setLoading", false, { root: true })
    });
};


export const historicoMovimentacao = ({ commit }, payload) => {
    commit("sessao/setLoading", true, { root: true })

    let config = {
        params: {
            dataInicial: payload.dataInicial,
            dataFinal: payload.dataFinal,
            cnes: payload.cnes
        }
    }

    return axios
    .get("/relatorios/listarHistoricoMovimentacaoLeito.php", config)
    .then(resp => {
        if (resp.data.status === true) commit('setHistoricoMovimentacao', resp.data.dados)
        if (resp.data.status === false) commit('setHistoricoMovimentacao', new Array())

        commit("sessao/setLoading", false, { root: true })
    })
    .catch(error => {
        console.error(error)
        commit("sessao/setLoading", false, { root: true })
    });
};

export const longaPermanencia = ({ commit }, payload) => {
    commit("sessao/setLoading", true, { root: true })

    let config = {
        params: {
            cnes: payload.cnes
        }
    }

    return axios
    .get("/relatorios/listarCasosLongaPermanencia.php", config)
    .then(resp => {
        if (resp.data.status === true) commit('setLongaPermanencia', resp.data.dados)
        if (resp.data.status === false) commit('setLongaPermanencia', new Array())

        commit("sessao/setLoading", false, { root: true })
    })
    .catch(error => {
        console.error(error)
        commit("sessao/setLoading", false, { root: true })
    });
};

export const listagemInternados = ({ commit }, payload) => {
    return axios
    .post("/relatorios/listarInternacoes.php", payload)
};